<cdk-accordion-item #accordionItem="cdkAccordionItem" role="button" [expanded]="false">
  <div (click)="accordionItem.toggle()" class="px-6 pt-5">
    <div class="mb-4 flex items-center gap-2">
      <div class="w-fit">
        @if (patientAvatar()) {
          <lib-avatars [persons]="[patientAvatar()]" [size]="44" [fontSize]="16" />
        }
      </div>
      <div class="flex flex-1 items-center justify-between">
        @if (patient()) {
          <div class="flex flex-col items-start justify-center gap-1">
            <h2 class="typo-h3-semibold">{{ patient()! | fullName }}</h2>
            <h5 class="typo-h6-light text-text-secondary">
              {{ patient()?.birthDate ?? '' | date }}
              {{ 'health_history_patient_age' | translate: { input1: (patient()?.birthDate ?? '' | age) } }}
            </h5>
          </div>
        }
        <div class="flex items-center gap-4">
          @if (accordionItem.expanded && !isEaglesoftPms()) {
            <button
              class="flex h-4 w-4 items-center justify-center p-0"
              (click)="onEditClick($event)"
              [disabled]="anyContactLockedByProvisional()"
              [libUiTooltip]="anyContactLockedByProvisional() ? provisionalTooltip : undefined"
              tooltipPosition="bottom"
            >
              <svg-icon
                class="h-4 w-4"
                [key]="anyContactProvisional() ? 'px-16-edit-pending' : 'px-16-edit'"
                [ngClass]="anyContactLockedByProvisional() ? 'text-text-light' : 'text-primary-blue'"
              ></svg-icon>
            </button>
          }
          <svg-icon class="text-primary-blue" [key]="accordionItem.expanded ? 'px-24-arrow-up' : 'px-24-arrow-down'"></svg-icon>
        </div>
      </div>
    </div>

    <div class="flex w-full justify-between gap-6">
      <lib-health-history-patient-details-item
        [icon]="'px-24-iphone'"
        [iconTooltipKey]="'health_history_patient_info_modal_mobile'"
        [displayText]="patient()?.mobilePhone ?? '-'"
      ></lib-health-history-patient-details-item>
      <lib-health-history-patient-details-item
        [icon]="'px-24-home'"
        [iconTooltipKey]="'health_history_patient_info_modal_home'"
        [displayText]="patient()?.homePhone ?? '-'"
      ></lib-health-history-patient-details-item>
    </div>
  </div>
  <div [@slideToggle]="accordionItem.expanded ? 'expanded' : 'collapsed'" class="overflow-hidden px-6 pb-6">
    <div class="my-4 min-h-[1px] min-w-full bg-background-disabled"></div>
    <lib-health-history-patient-secondary-contacts [contacts]="secondaryContacts()" />
  </div>
</cdk-accordion-item>

<ng-template #provisionalTooltip>
  <div class="typo-h7-light max-w-[200px] whitespace-pre-wrap p-1">
    {{ 'health_history_patient_info_edit_disabled_tooltip' | translate }}
  </div>
</ng-template>
